import { injectReducer } from "store/reducers";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import StudentAssignment from "./routes/StudentAssignment";
import AllSubmissions from "./routes/AllSubmissions";
import ClassRoomMediaManager from "./routes/ClassRoomMediaManager";
import TeacherView from "./routes/TeacherView";
import WorksheetScorebook from "./routes/WorksheetScorebook";
import Monitoring from "./routes/Monitoring";
import EvaluationInsights from "./routes/EvaluationInsights";
import AssessmentBasicDetails from "./routes/AssessmentBasicDetails";

export default store => ({
  path: "classroom-details/:classRoomId",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "classroom-details" */ "./components"),
        import(
          /* webpackChunkName: "classroom-details" */ "ClassRoom/modules/ClassRoomModule"
        ),
        import(
          /* webpackChunkName: "classroom-details" */ "Worksheet/modules/WorksheetModules"
        ),
        import(
          /* webpackChunkName: "classroom-details" */ "Post/modules/PostModule"
        ),
      ]).then(
        ([
          importedModule0,
          importedModule1,
          importedModule2,
          importedModule3,
        ]) => {
          const component = importedModule0.default;
          const reducer = importedModule1.default;
          const worksheetModule = importedModule2;
          const post = importedModule3.default;
          injectReducer(store, {
            key: "classRoom",
            reducer,
          });
          injectReducer(store, {
            key: worksheetModule.NAME,
            reducer: worksheetModule.default,
          });
          injectReducer(store, {
            key: "post",
            reducer: post,
          });
          return component;
        }
      )
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [
    AllSubmissions(store),
    ClassRoomMediaManager(store),
    TeacherView(store),
    WorksheetScorebook(store),
    Monitoring(store),
    EvaluationInsights(store),
    AssessmentBasicDetails(store),
    StudentAssignment(store),
  ],
});
